import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { Observable, Subject } from 'rxjs';
import { filter, map, pairwise, tap } from 'rxjs/operators';

import { HttpHelper } from '@helpers/http.helper';

export interface Reload {
  reload(): void;
}

@Injectable({
  providedIn: 'root'
})
export class ReloadService {
  private navigationSubject$ = new Subject<boolean>();
  private readonly baseRoute: RegExp = /^\/companies\/\d+(\/.*)?/;

  get navigationSubject(): Observable<boolean> {
    return this.navigationSubject$.asObservable();
  }

  constructor(private router: Router) {
    this.router.events
      .pipe(
        // On ne prend que les navigations réussies
        filter(e => e instanceof NavigationEnd),
        // Enlève les QueryParams de l'url
        map((e: NavigationEnd) => HttpHelper.sanitizeUrl(e.url)),
        // Stock l'url précédente et la courante
        // On en besoin pour comparer qu'on a bien changé d'url
        pairwise(),
        // Vérification que les deux URL valide la RegExp
        filter(
          ([previousUrl, currentUrl]: string[]) => this.baseRoute.test(previousUrl) && this.baseRoute.test(currentUrl)
        ),
        // On map pour n'avoir que les companyId
        map(([previousUrl, currentUrl]: string[]) => [previousUrl.match(/\d+/)?.[0], currentUrl.match(/\d+/)?.[0]]),
        // On vérifie que les ids sont différent
        filter(([previousCompanyId, currentCompanyId]) => previousCompanyId !== currentCompanyId),
        tap(() => this.reloadCurrentView())
      )
      .subscribe();
  }

  reloadCurrentView(preserveParams?: boolean): void {
    this.navigationSubject$.next(preserveParams);
  }
}
